const sectionPathPairs = [
  { path: "/dashboard", section: "dashboard" },
  { path: "/process-management", section: "process-management" },
  { path: "/processes/:processId", section: "process-view" },
  { path: "/process-create", section: "process-create" },
  { path: "/processes/:processId/edit", section: "process-edit" },
  { path: "/process-creation", section: "process-creation" },
  { path: "/task-management", section: "task-management" },
  { path: "/task-create", section: "task-create" },
  { path: "/tasks/:taskId", section: "task-detail" },
  { path: "/tasks/:taskId/edit", section: "task-edit" },
  { path: "/job-management", section: "job-management" },
  { path: "/job-workload", section: "job-workload" },
  { path: "/jobs/:jobId", section: "job-detail" },
  { path: "/job-create", section: "job-create" },
  { path: "/jobs/:jobId/edit", section: "job-edit" },
  { path: "/function-management", section: "function-management" },
  { path: "/functions/:functionId", section: "function-detail" },
  { path: "/functions/:functionId/edit", section: "function-edit" },
  { path: "/function-create", section: "function-create" },
  { path: "/companies", section: "companies" },
  { path: "/company-management", section: "company-management" },
  { path: "/organization-management", section: "organization-management" },
  { path: "/buildings", section: "buildings" },
  { path: "/building-create", section: "building-create" },
  { path: "/buildings/:buildingId", section: "building-detail" },
  { path: "/buildings/:buildingId/edit", section: "building-edit" },
  { path: "/building-floors", section: "building-floors" },
  { path: "/building-layout", section: "building-layout" },
  { path: "/floor-create", section: "floor-create" },
  { path: "/floors/:floorId/edit", section: "floor-edit" },
  { path: "/floors/:floorId", section: "floor-detail" },
  { path: "/rooms", section: "rooms" },
  { path: "/people-management", section: "people-management" },
  { path: "/people-create", section: "people-create" },
  { path: "/people/:personId/edit", section: "people-edit" },
  { path: "/people/:personId", section: "people-view" },
  { path: "/what-if-analysis", section: "what-if-analysis" },
  { path: "/process-optimization", section: "process-optimization" },
  {
    path: "/process-optimization/results/:processId",
    section: "process-optimization-results",
  },
  { path: "/process-optimization-copy", section: "process-optimization-copy" },
  { path: "/substitution-analyst", section: "substitution-analyst" },
  { path: "/capi-paei-analysis", section: "capi-paei-analysis" },
  { path: "/process-visualization", section: "process-visualization" },
  { path: "/bpmn-viewer", section: "bpmn-viewer" },
  { path: "/process-builder", section: "process-builder" },
  { path: "/process-usecase", section: "process-usecase" },
  { path: "/functional-hierarchy", section: "functional-hierarchy" },
  // C-Level (New) temporarily hidden (nav + URL)
  // { path: "/c-level-library-new", section: "c-level-library-new" },
  { path: "/c-level-org-chart", section: "c-level-org-chart" },
  { path: "/unassigned-entities", section: "unassigned-entities" },
  { path: "/ai-processes", section: "ai-processes" },
  { path: "/role-management", section: "role-management" },
  { path: "/users-3d-management", section: "users-3d-management" },
  { path: "/user-access", section: "user-access" },
  { path: "/audit-logs", section: "audit-logs" },
  { path: "/asset-task-management", section: "asset-task-management" },
  { path: "/asset-task-create", section: "asset-task-create" },
  { path: "/asset-tasks/:assetTaskId/edit", section: "asset-task-edit" },
  { path: "/asset-tasks/:assetTaskId", section: "asset-task-detail" },
  { path: "/kpi-management", section: "kpi-management" },
  { path: "/kpi-create", section: "kpi-create" },
  { path: "/kpis/:kpiId/edit", section: "kpi-edit" },
  { path: "/uom-management", section: "uom-management" },
  { path: "/kpi-attribute-management", section: "kpi-attribute-management" },
  {
    path: "/process-category-attributes",
    section: "process-category-attributes",
  },
  { path: "/process-status", section: "process-status" },
  { path: "/task-category-attributes", section: "task-category-attributes" },
  { path: "/task-status", section: "task-status" },
  { path: "/job-category-attributes", section: "job-category-attributes" },
  { path: "/job-status", section: "job-status" },
  { path: "/process-kpi", section: "process-kpi" },
  { path: "/countries", section: "countries" },
  { path: "/country-create", section: "country-create" },
  { path: "/countries/:countryId/edit", section: "country-edit" },
  { path: "/cities", section: "cities" },
  { path: "/city-create", section: "city-create" },
  { path: "/cities/:cityId/edit", section: "city-edit" },
  { path: "/help", section: "help-docs" },
  { path: "/help/:topicId", section: "help-topic" },
];

export const DEFAULT_SECTION = "dashboard";
export const DEFAULT_PATH = "/dashboard";

const sectionToPathMap = {};
const staticPathToSection = { "/": DEFAULT_SECTION };
const dynamicRouteMatchers = [];

const buildDynamicRegex = (pattern) => {
  const escaped = pattern.replace(/:[^/]+/g, "([^/]+)");
  return new RegExp(`^${escaped}$`);
};

sectionPathPairs.forEach(({ section, path }) => {
  sectionToPathMap[section] = path;
  if (path.includes(":")) {
    dynamicRouteMatchers.push({ section, regex: buildDynamicRegex(path) });
  } else {
    staticPathToSection[path] = section;
  }
});

export const sectionToPath = sectionToPathMap;
export const pathToSection = staticPathToSection;

export const normalizePathname = (pathname = "/") => {
  if (!pathname) return "/";
  if (pathname === "/") return "/";
  return pathname.endsWith("/") && pathname.length > 1 ?
      pathname.slice(0, -1)
    : pathname;
};

export const getSectionFromPath = (pathname) => {
  const normalized = normalizePathname(pathname);
  if (pathToSection[normalized]) return pathToSection[normalized];
  for (const matcher of dynamicRouteMatchers) {
    if (matcher.regex.test(normalized)) return matcher.section;
  }
  return DEFAULT_SECTION;
};
